import React, { Fragment, useState, useEffect } from 'react';

const ToggleFilter = ({
    filterTitle,
    filterName,
    filters,
    updateFilters,
    options,
    filterContainer,
}) => {
    const filterId = filterName + (filterContainer ? filterContainer : '');
    const [value, setValue] = useState(false);

    useEffect(() => {
        setValue(filters[filterName]);
    }, [filters[filterName]]);

    const onChangeFunction = () => {
        let newValue = !value;
        setValue(newValue);
        updateFilters({ ...filters, [filterName]: newValue });
    };

    return (
        <Fragment>
            <div className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                    <button
                        className="c-accordion__title-label  js-accordion__title-label"
                        aria-expanded="true"
                        type="button"
                    >
                        <span className="c-accordion__title-label-text">
                            {filterTitle}
                        </span>
                    </button>
                </h3>
            </div>
            <div
                className="c-accordion__panel  js-accordion__panel c-vehicle-filters__item-content"
                aria-hidden="true"
            >
                <div
                    className={
                        'c-accordion__content c-vehicle-filters__' + filterName
                    }
                >
                    <div className="c-toggle  c-toggle--on-off">
                        <label htmlFor={filterId}>
                            {options.leftText ? (
                                <span className="c-toggle__text">
                                    {options.leftText}
                                </span>
                            ) : null}
                            <input
                                className="c-toggle__input"
                                type="checkbox"
                                name="toggle"
                                id={filterId}
                                onChange={onChangeFunction}
                                checked={value}
                            />
                            <span className="c-toggle__text">
                                {options.rightText}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ToggleFilter;
